<div class="groupContainer">
  <div *ngIf="designGroup.groupName !== ''" class="groupHeader" >
    <div class="groupClick" *ngIf="!this.editingExistingGroup.get(this.designGroup.groupId)" (pointerup)="this.startEditDesignGroup(this.designGroup)">
      <span data-tour="stepDesign11">
      <mat-icon class="icon-group">
        <i class="material-icons md-32">grid_view</i>
      </mat-icon>
      {{this.designGroup.groupName}}</span>
    </div>
    <div class="groupEdit" *ngIf="this.editingExistingGroup.get(this.designGroup.groupId)" (keydown)="this.editDesignGroup($event)">
      <form [formGroup]="editGroupForm">
        <div class="design-group-input-name">
          <mat-form-field>
            <mat-label>Gruppe</mat-label>
            <input maxlength="30" matInput formControlName="groupname" emAutoFocus [matAutocomplete]="auto" />
            <mat-autocomplete #auto="matAutocomplete">
              @for (option of filteredOptions | async; track option) {
              <mat-option [value]="option">{{option}}</mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="design-group-input-button-row">
          <div class="design-group-input-flex-container">
            <button mat-raised-button color="accent" (click)="this.saveDesignGroup(this.designGroup)">
              <mat-icon>check</mat-icon>
            </button>
            <button mat-raised-button (click)="this.cancelGroupEdit()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="cardWebList_container">
        <mat-card *ngIf="designGroup.groupId === 0" class="cardWeb-card add-card" (pointerup)="startAdd()" data-tour="stepDesign1">
            <ng-container *ngIf="!addingNew" class="add-trigger">
                <mat-card-header>
                    <mat-card-title class="add-card-title">
                        <mat-icon class="plusSign">add</mat-icon><br/><br/>
                        Neues Design
                    </mat-card-title>
                </mat-card-header>
            </ng-container>
            <div *ngIf="addingNew" data-tour="stepDesign5">
                <mat-card-content>
                    <form [formGroup]="addForm">
                        <mat-form-field appearance="fill" class="full-width" data-tour="stepDesign2">
                            <mat-label>Name</mat-label>
                            <input maxlength="30" matInput formControlName="name" emAutoFocus/>
                        </mat-form-field>

                        <mat-form-field appearance="fill" class="full-width" data-tour="stepDesign3">
                            <mat-label>Beschreibung</mat-label>
                            <textarea style="resize: none" maxlength="220" matInput formControlName="description"></textarea>
                        </mat-form-field>

                        <mat-form-field appearance="fill" class="full-width" data-tour="stepDesign4">
                            <mat-label>Gruppe</mat-label>
                            <input maxlength="30"
                                   matInput
                                   formControlName="groupname"
                                   [matAutocomplete]="auto"/>
                            <mat-autocomplete #auto="matAutocomplete">
                                @for (option of filteredOptions | async; track option) {
                                <mat-option [value]="option">{{option}}</mat-option>
                                }
                            </mat-autocomplete>
                        </mat-form-field>
                    </form>
                </mat-card-content>

                <mat-card-actions align="end" class="actions">
                    <button id="cancelAddButton" mat-button (click)="cancelAdd()">Abbrechen</button>
                    <button
                            mat-raised-button
                            color="accent"
                            [disabled]="addForm.invalid"
                            (click)="submitAdd()">
                        Speichern
                    </button>
                </mat-card-actions>
            </div>
        </mat-card>
        <ng-container *ngFor="let design of designs">
            <mat-card class="cardWeb-card" (click)="!this.designCanBeOpened(design) ? this.startEdit(design):null" appearance="outlined" [routerLink]="this.designCanBeOpened(design) ? ['/editor', this.cardDeckId, design.name, this.getTimestamp(design)]: null"
                      routerLinkActive="activeLink" data-tour="stepDesign6">
              <ng-container *ngIf="!editingExistingDesign.get(this.createIdFromCreatedDate(design))" class="add-trigger">
                    <!-- 3-dot menu trigger -->
                    <button
                            class="card-menu-button"
                            data-tour="stepDesign7"
                            [matMenuTriggerFor]="cardMenu"
                            (click)="$event.stopPropagation()">
                        <mat-icon>more_horiz</mat-icon>
                    </button>

                    <!-- the actual menu -->
                    <mat-menu #cardMenu="matMenu">
                        <button mat-menu-item (click)="startEdit(design)" data-tour="stepDesign8">
                            <mat-icon>edit</mat-icon>
                            <span>Ändern</span>
                        </button>
                        <button *ngIf="design.name !== this.dummyDesignName && (design.designInvitationElement === null || design.designInvitationElement.shareOption ==='edit')" mat-menu-item (click)="copyDesign(design)" data-tour="stepDesign9">
                            <mat-icon>content_copy</mat-icon>
                            <span>Duplizieren</span>
                        </button>
                        <button *ngIf="design.name !== this.dummyDesignName && design.designInvitationElement === null" mat-menu-item (click)="openShareDialog(design, $event, 0)" data-tour="stepDesign9b">
                          <mat-icon>person_add</mat-icon>
                          <span>Einladen</span>
                        </button>
                        <button *ngIf="design.designInvitationElement === null" mat-menu-item (click)="deleteDesign(design)" data-tour="stepDesign10">
                            <mat-icon>delete_forever</mat-icon>
                            <span>Löschen</span>
                        </button>
                        <button *ngIf="design.designInvitationElement !== null" mat-menu-item (click)="deleteInvitation(design)" data-tour="stepDesign10">
                          <mat-icon>group_off</mat-icon>
                          <span>Entfernen</span>
                        </button>
                    </mat-menu>
                    <em-card-visualization *ngIf="design.positionings.length > 0" [positionings]="design.positionings"></em-card-visualization>
                    <ng-container *ngIf="design.positionings.length === 0">
                      <div class="canvasPlaceholder">
                        <mat-icon class="emptyTableIcon">
                          <i class="material-icons md-32">lens_blur</i>
                        </mat-icon>
                      </div>
                    </ng-container>
                    <div class="design_title_description_container description_box">
                        <mat-card-header class="design_title">
                            <mat-card-title>
                             <mat-icon (click)="$event.stopPropagation(); this.openShareDialog(design,$event,1);" *ngIf="design.designInvitationElement === null && design.numberOfInvitations > 0" class="share-icon" matTooltip="{{this.getTooltipForInvitations(design.numberOfInvitations)}}">group</mat-icon>
                              <ng-container *ngIf="design.designInvitationElement !== null">
                                <ng-container *ngIf="avatarTemplateCommunityMemberMap.get(design.designInvitationElement.senderAppId) | async as communityMemberSender">
                                  <a target="_blank" href="{{this.getCommunityMessageUrl(design.designInvitationElement.postUrl)}}"><img (click)="$event.stopPropagation();" matTooltip="Einladung von {{design.designInvitationElement.senderUsername}}" class="avatar-icon" *ngIf="design.designInvitationElement !== null" src="{{this.getAvatarTemplateUrl(communityMemberSender.avatarTemplate)}}" alt="avatarImage"></a>
                                </ng-container>
                                <ng-container *ngIf="design.designInvitationElement.shareOption === 'edit'"><span class="material-symbols-outlined radio-icon">edit_square</span></ng-container>
                                <ng-container *ngIf="design.designInvitationElement.shareOption === 'view'"><span class="material-symbols-outlined radio-icon">visibility</span></ng-container>
                              </ng-container>
                              {{this.decodeDesignName(design.name)}}
                            </mat-card-title>
                            <mat-card-subtitle>{{ design.lastModifiedDateTime | date:"short":'':'de-De'}}</mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content class="design_description">
                            <p class="description_text">
                                {{
                                design.description
                                }}
                            </p>
                        </mat-card-content>
                    </div>
                </ng-container>

                <!-- show form -->
                <ng-container *ngIf="editingExistingDesign.get(this.createIdFromCreatedDate(design))">
                    <!--mat-card-header>
                      <mat-card-title>Neues Projekt</mat-card-title>
                    </mat-card-header-->

                    <mat-card-content>
                        <form [formGroup]="editForm">
                            <mat-form-field *ngIf="design.designInvitationElement === null" appearance="fill" class="full-width" data-tour="stepDataImport1">
                                <mat-label>Name</mat-label>
                                <input maxlength="30" matInput formControlName="name" emAutoFocus/>
                            </mat-form-field>

                            <mat-form-field *ngIf="design.designInvitationElement === null" appearance="fill" class="full-width">
                                <mat-label>Beschreibung</mat-label>
                                <textarea style="resize: none" maxlength="220" matInput formControlName="description"></textarea>
                            </mat-form-field>

                            <mat-form-field appearance="fill" class="full-width" data-tour="stepDesign10">
                                <mat-label>Gruppe</mat-label>
                                <input maxlength="30"
                                       matInput
                                       formControlName="groupname"
                                       [matAutocomplete]="auto"/>
                                <mat-autocomplete #auto="matAutocomplete">
                                    @for (option of filteredOptions | async; track option) {
                                    <mat-option [value]="option">{{option}}</mat-option>
                                    }
                                </mat-autocomplete>
                              <mat-hint *ngIf="design.designInvitationElement !== null">Bei einem Design, das eine andere Person geteilt hast, kannst nur die <strong>Gruppe</strong> ändern.</mat-hint>
                            </mat-form-field>
                        </form>
                    </mat-card-content>

                  <mat-card-actions align="end" class="actions">
                    <button mat-button (pointerup)="cancelEdit(design)">Abbrechen</button>
                    <button
                      mat-raised-button
                      color="accent"
                      [disabled]="editForm.invalid"
                      (click)="saveEdit(design)">
                      Speichern
                    </button>
                  </mat-card-actions>
                </ng-container>
            </mat-card>
        </ng-container>
    </div>
</div>

<ng-template #resetConfirmDialog>
  <div class="modal-wrapper">
    <div class="headline-wrapper">
      <span>Design Löschen</span>
    </div>
    <mat-dialog-content>
      <span class="dialog-content">Möchtest du das Design wirklich löschen? Alle Karten und Verbindungen werden gelöscht. Dieser Vorgang ist nicht rückgängig zu machen.</span>
      <div class="spacer"></div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="cancelDelete()">Abbrechen</button>
      <button mat-raised-button color="accent" [mat-dialog-close]="true">Löschen</button>
    </mat-dialog-actions>
  </div>
</ng-template>

<ng-template #noResetAllowedDialog>
  <div class="modal-wrapper">
    <div class="headline-wrapper">
      <span>Design Löschen</span>
    </div>
    <mat-dialog-content>
      <span class="dialog-content">Du kannst dein Design nicht löschen, da du es im Moment noch mit anderen Community-Mitgliedern geteilt hast. Nimm erst alle ausgesprochenen Einladungen zurück, bevor du das Design endgültig löschst.</span>
      <div class="spacer"></div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="cancelDelete()">Abbrechen</button>
      <button mat-raised-button color="accent" [mat-dialog-close]="true">Weiter</button>
    </mat-dialog-actions>
  </div>
</ng-template>

<ng-template #deleteDesignInvitationDialog>
  <div class="modal-wrapper">
    <div class="headline-wrapper">
      <span>Design entfernen</span>
    </div>
    <mat-dialog-content>
      <span class="dialog-content">Möchtest du das mit dir geteilte Design wirklich entfernen? Dieser Vorgang ist nicht rückgängig zu machen. Um erneut auf das Design zugreifen zu können, musst du erst wieder neu eingeladen werden.</span>
      <div class="spacer"></div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="cancelDelete()">Abbrechen</button>
      <button mat-raised-button color="accent" [mat-dialog-close]="true">Entfernen</button>
    </mat-dialog-actions>
  </div>
</ng-template>

<ng-template #dataMigrationDialog>
  <div class="modal-wrapper">
    <div class="headline-wrapper">
      <span>Herzlich Willkommen ...</span>
    </div>
    <mat-dialog-content>
      <span class="dialog-content">... zur neuen Version der EMPAMOPS-WebApp!<br/><br/> Bislang hattest du nur <strong>einen</strong> Kartentisch zur Verfügung. Ab jetzt kannst du <strong>viele</strong> Kartentische speichern und verwalten.<br/><br/>Unter dem Namen <strong>{{ this.dummyDesignName }}</strong> ist das Design deines alten Kartentisches bereits importiert worden. Bevor du auf das importierte Design zugreifen kannst, musst du ihm erst einen eigenen Namen geben.</span>
      <div class="spacer"></div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="cancelImport()">Abbrechen</button>
      <button mat-raised-button color="accent" [mat-dialog-close]="true">Design umbenennen</button>
    </mat-dialog-actions>
  </div>
</ng-template>

<ng-template #askOnboardingTour>
  <div class="modal-wrapper">
    <div class="headline-wrapper">
      <span>Import abgeschlossen</span>
    </div>
    <mat-dialog-content>
      <span class="dialog-content">Du hast dein Design erfolgreich umbenannt und importiert. Bevor du loslegst, empfehlen wir dir, die Onboarding-Tour zu starten. Dies gibt dir einen schnellen Überblick, wie du auf dieser Seite neue Designs erstellen und verwalten kannst. Du kannst die Onbording-Tour auch später noch jederzeit über das Menü rechts oben in der Ecke starten.</span>
      <div class="spacer"></div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="cancelOnboarding()">Abbrechen</button>
      <button mat-raised-button color="accent" [mat-dialog-close]="true">Onboarding-Tour starten</button>
    </mat-dialog-actions>
  </div>
</ng-template>
